import React from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import { 
  TextField, 
  Button, 
  Grid, 
  Container,
  Typography,
  Paper,
  Box,
  Divider
} from '@material-ui/core';
import {
  LocationOn as LocationIcon,
  WhatsApp as WhatsAppIcon,
  Email as EmailIcon,
  Send as SendIcon,
  Chat as ChatIcon
} from '@material-ui/icons';
import Footer from '../layout/footer';
import Header from '../layout/header';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  hero: {
    padding: theme.spacing(8, 0),
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    textAlign: 'center',
  },
  section: {
    padding: theme.spacing(6, 0),
  },
  contactCard: {
    padding: theme.spacing(4),
    marginBottom: theme.spacing(4),
    transition: 'transform 0.3s, box-shadow 0.3s',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: theme.shadows[6],
    },
  },
  formContainer: {
    padding: theme.spacing(4),
  },
  contactMethod: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  icon: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  submitButton: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5),
  },
  textField: {
    marginBottom: theme.spacing(3),
  },
}));

export default function ContactPage() {
  const classes = useStyles();
  const [fullName, setFullName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [message, setMessage] = React.useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/emails/send', {
        fullName,
        email,
        message
      });
      alert('Your message has been sent successfully!');
      setFullName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <div className={classes.root}>
      <Header />
      
      {/* Hero Section */}
      <div className={classes.hero}>
        <Container maxWidth="md">
          <Typography variant="h2" component="h1" gutterBottom>
            Contact Us
          </Typography>
          <Typography variant="h5" color="textSecondary">
            We're here to help and answer any questions you might have
          </Typography>
        </Container>
      </div>

      {/* Main Content */}
      <Container maxWidth="lg" className={classes.section}>
        <Grid container spacing={6}>
          {/* Contact Form Column */}
          <Grid item xs={12} md={7}>
            <Paper elevation={3} className={classes.contactCard}>
              <Typography variant="h5" gutterBottom>
                <ChatIcon className={classes.icon} />
                Send us a message
              </Typography>
              
              <form onSubmit={handleSubmit} className={classes.formContainer}>
                <TextField
                  className={classes.textField}
                  fullWidth
                  label="Your full name"
                  variant="outlined"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
                
                <TextField
                  className={classes.textField}
                  fullWidth
                  label="Your email address"
                  variant="outlined"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                
                <TextField
                  className={classes.textField}
                  fullWidth
                  label="Your message"
                  variant="outlined"
                  multiline
                  rows={6}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
                
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.submitButton}
                  fullWidth
                  startIcon={<SendIcon />}
                >
                  Send Message
                </Button>
              </form>
            </Paper>
          </Grid>

          {/* Contact Methods Column */}
          <Grid item xs={12} md={5}>
            <Paper elevation={3} className={classes.contactCard}>
              <Typography variant="h5" gutterBottom>
                Other ways to reach us
              </Typography>
              
              <Box component="div" className={classes.contactMethod}>
                
                <EmailIcon className={classes.icon} fontSize="large" />
                <div>
                  <Typography variant="subtitle1">Email us</Typography>
                  <Typography variant="body2" color="textSecondary">
                    <a 
                      href="https://mail.google.com/mail/u/0/?fs=1&to=tradingandcoffee.ou@gmail.com" 
                      target="_blank" 
                      rel="noreferrer"
                      style={{ color: 'inherit', textDecoration: 'none' }}
                    >
                      tradingandcoffee.ou@gmail.com
                    </a>
                  </Typography>
                </div>
              </Box>
              
              <Divider />
              
              
              <Box component="div" className={classes.contactMethod}>
                <LocationIcon className={classes.icon} fontSize="large" />
                <div>
                  <Typography variant="subtitle1">Our location</Typography>
                  <Typography variant="body2" color="textSecondary">
                  Tallinn Estonia
                  <br />
                    
                  </Typography>
                </div>
              </Box>
            </Paper>
            
            {/* Response Time Info */}
            <Paper elevation={3} className={classes.contactCard}>
              <Typography variant="h6" gutterBottom>
                Response Time
              </Typography>
              <Typography variant="body1" paragraph>
                We typically respond to messages within 24 hours during business days.
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Business hours: Mon-Fri, 9AM-5PM EST
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      
      <Footer />
    </div>
  );
}